module.exports = __webpack_public_path__ + "981a6a1d960437e89e09899da6ed525f.eot";


/*****************
 ** WEBPACK FOOTER
 ** ./src/app/assets/fonts/hmr.eot
 ** module id = 30
 ** module chunks = 0
 **/